// Result of POST /settings/key/test. On failure, known Binance rejections
// come with an actionable `friendly` explanation ({title, action}) while the
// raw Binance message stays visible for support; unknown ones fall back to
// the plain message. On success, lists the permissions Binance reported.
function KeyTestResult({ result }) {
    if (!result) return null;

    if (!result.ok)
        return (
            <div className="alert alert-danger py-2 mt-2 mb-0 small">
                {result.friendly ? (
                    <>
                        <div className="fw-bold mb-1">
                            {result.friendly.title}
                        </div>
                        <p className="mb-1">{result.friendly.action}</p>
                        <small className="text-muted">
                            Binance said: {result.message}
                        </small>
                    </>
                ) : (
                    <>Binance rejected this key: {result.message}</>
                )}
            </div>
        );

    const permissions = [
        ['Reading', result.data.enableReading],
        ['Spot & Margin Trading', result.data.enableSpotAndMarginTrading],
        ['Futures', result.data.enableFutures],
        ['Withdrawals', result.data.enableWithdrawals],
        ['IP restricted', result.data.ipRestrict],
    ].filter(([, value]) => value !== undefined);

    return (
        <div className="alert alert-success py-2 mt-2 mb-0 small">
            {permissions.map(([label, enabled]) => (
                <span key={label} className="d-block">
                    {label}: {enabled ? 'Yes' : 'No'}
                </span>
            ))}
        </div>
    );
}

export default KeyTestResult;
